import { render, staticRenderFns } from "./ChoosePurchaseItem.vue?vue&type=template&id=0187f3ab&scoped=true"
import script from "./ChoosePurchaseItem.vue?vue&type=script&lang=js"
export * from "./ChoosePurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./ChoosePurchaseItem.vue?vue&type=style&index=0&id=0187f3ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187f3ab",
  null
  
)

export default component.exports